import { cssUtil } from "../../utils/cssUtil";
import { getBaseStyles } from "../commonStyles";


export async function renderTextareaFieldWidget(context, widget, parent, override = null) {

    const device = widget?.properties?.desktop;
    if (!device) return;

    // <div class="widget form_field_widget">
    const container = context.document.createElement("div");
    container.classList.add("widget", "form_field_widget");
    const breakpoint = context.currentBreakpoint;

    const styles = {
        ...getBaseStyles(widget, breakpoint)
    };

    applyFieldStyles(styles, device);
    container.setAttribute("style", cssUtil.toStyleString(styles));
    container.setAttribute("data-widgetId", widget.uid);
    container.setAttribute("data-widgetType", widget.type);
    container.setAttribute("data-widgetParent", widget.parent);
    parent.appendChild(container);

    // Label
    const labelEl = renderLabel(context, device);
    if (labelEl) container.appendChild(labelEl);

    // Textarea (HTML-only div)
    const inputEl = renderInput(context, device);
    container.appendChild(inputEl);

    return container;
}

function renderLabel(context, device) {
    if (!device.label) return null;

    const el = context.document.createElement("div");
    el.innerHTML = device.label;

    const styles = {};
    applyLabelStyles(styles, device);

    el.setAttribute("style", cssUtil.toStyleString(styles));
    return el;
}

function renderInput(context, device) {
    const el = context.document.createElement("div");
    el.classList.add("input-text-area");

    if (device.placeholder) {
        el.innerHTML = device.placeholder;
    }

    const styles = {};
    applyInputStyles(styles, device);

    el.setAttribute("style", cssUtil.toStyleString(styles));
    return el;
}

function applyFieldStyles(styles, device) {
    const alignment = device.styles?.layout?.alignment;
    if (alignment) {
        styles["text-align"] = alignment;
    }
}

function applyLabelStyles(styles, device) {
    const layout = device.styles?.layout;
    const regular = device.styles?.regular;
    if (!layout || !regular) return;

    const alignment = layout.alignment;
    const fieldSpacing = layout.fieldSpacing;
    const labelPadding = layout.labelPadding;

    if (fieldSpacing) {
        styles["padding-bottom"] = `${fieldSpacing}px`;
    }

    if (labelPadding) {
        if (alignment === "left") {
            styles["padding-left"] = `${labelPadding}px`;
        } else if (alignment === "right") {
            styles["padding-right"] = `${labelPadding}px`;
        }
    }

    // Label color
    if (regular.label?.color) {
        styles.color =
            regular.label.color.type === "gradient"
                ? cssUtil.getCssGradient(regular.label.color)
                : cssUtil.getCssColor(regular.label.color);
    }

    applyFontStyles(styles, regular.label);
}

function applyInputStyles(styles, device) {
    const layout = device.styles?.layout;
    const regular = device.styles?.regular;
    if (!layout || !regular) return;

    const alignment = layout.alignment;
    const inputPadding = layout.inputPadding;

    if (inputPadding) {
        if (alignment === "left") {
            styles["padding-left"] = `${inputPadding}px`;
        } else if (alignment === "right") {
            styles["padding-right"] = `${inputPadding}px`;
        }
    }
    // Background
    if (regular.input?.background) {
        styles.background =
            regular.input.background.type === "gradient"
                ? cssUtil.getCssGradient(regular.input.background)
                : cssUtil.getCssColor(regular.input.background);
    }

    // Placeholder color
    if (regular.input?.placeholderColor) {
        styles.color =
            regular.input.placeholderColor.type === "gradient"
                ? cssUtil.getCssGradient(regular.input.placeholderColor)
                : cssUtil.getCssColor(regular.input.placeholderColor);
    }

    applyFontStyles(styles, regular.input);
    applyBorderStyles(styles, regular.border);
}

function applyFontStyles(styles, fontStyle) {
    if (!fontStyle?.font) return;

    const font = fontStyle.font;

    if (font.fontFamily) styles["font-family"] = font.fontFamily;
    if (font.fontSize) styles["font-size"] = `${font.fontSize}px`;
    if (font.lineSpacing) styles["line-height"] = `${font.lineSpacing}em`;
    if (font.letterSpacing) styles["letter-spacing"] = `${font.letterSpacing}em`;
}

function applyBorderStyles(styles, border) {
    if (!border) return;

    const r = border.radius;
    if (r) {
        if (r.topLeft) styles["border-top-left-radius"] = `${r.topLeft}px`;
        if (r.topRight) styles["border-top-right-radius"] = `${r.topRight}px`;
        if (r.bottomLeft) styles["border-bottom-left-radius"] = `${r.bottomLeft}px`;
        if (r.bottomRight) styles["border-bottom-right-radius"] = `${r.bottomRight}px`;
    }

    if (border.color) {
        styles["border-color"] =
            border.color.type === "gradient"
                ? cssUtil.getCssGradient(border.color)
                : cssUtil.getCssColor(border.color);
    }

    const width = border.width;
    let borderWidth = parseInt(width || "0", 10);

    if (width) {
        if (border.style === "all") {
            styles["border-width"] = `${width}px`;
            borderWidth *= 2;
        } else {
            styles["border-bottom-width"] = `${width}px`;
        }
    }

    // Same calculation as Java
    styles["line-height"] = `${37 - borderWidth}px`;
}